export const ErrorIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="77"
            height="67"
            viewBox="0 0 77 67"
        >
            <defs>
                <path id="path-1" d="M34.8913043 -1.24344979e-13L2.13162821e-14 59.673913 68.8043478 59.673913z"></path>
            </defs>
            <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
                <g transform="translate(-802 -384)">
                    <g transform="translate(806 388)">
                        <g>
                            <g strokeLinejoin="round">
                                <use fill="#E5E5E5" xlinkHref="#path-1"></use>
                                <path
                                    stroke="#E5E5E5"
                                    strokeWidth="3.261"
                                    d="M34.911-3.265l36.695 64.57H-2.842l37.753-64.57z"
                                ></path>
                                <path
                                    stroke="#FFF"
                                    strokeWidth="3.261"
                                    d="M34.871 3.265L2.842 58.043h63.16L34.872 3.265z"
                                ></path>
                            </g>
                            <path
                                fill="#CCC"
                                fillRule="nonzero"
                                d="M35.819 45.008l.936-12.152v-9.228h-3.879v9.228l.994 12.152h1.949zm.86 6.688V47.72h-3.803v3.975h3.802z"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}
